module.exports = __webpack_public_path__ + "static/media/logo_image.4a798e18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/logo_image.svg
// module id = 221
// module chunks = 0